import {
  FaChrome,
  FaFirefox,
  FaEdge,
  FaSafari,
  FaOpera,
  FaInternetExplorer,
} from "react-icons/fa";
import type { IconType } from "react-icons";
import { Globe } from "lucide-react";

// Logos de marque navigateur (react-icons / Font Awesome Brands). Le `name` vient
// de parseBrowser(user_agent) cote page (re-derive pour corriger Edge/Opera mal
// detectes). Fallback Globe (lucide) pour "Unknown" / non reconnu.
const BROWSER_ICONS: Record<string, IconType> = {
  Chrome: FaChrome,
  Firefox: FaFirefox,
  Edge: FaEdge,
  Safari: FaSafari,
  Opera: FaOpera,
  IE: FaInternetExplorer,
};

export function BrowserIcon({
  name,
  className = "h-4 w-4 shrink-0 text-muted-foreground",
}: {
  name?: string | null;
  className?: string;
}) {
  const Icon = (name ? BROWSER_ICONS[name] : undefined) ?? Globe;
  const label = name || "Navigateur inconnu";
  return (
    <span className="inline-flex" role="img" aria-label={label} title={label}>
      <Icon className={className} aria-hidden />
    </span>
  );
}
